export const ERRORS = {
	PHONE_EMPTY: 'Please enter your phone number',
	PHONE_INVALID: 'Please enter a valid phone number',
	DIFFERENT_PHONE: 'Please enter the same number given to the merchant',
	SOMETHING_WENT_WRONG: 'Something went wrong.',
};
